export default "__VITE_ASSET__BTsXMWc___"